import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as styles from './Textarea.scss';

/**
 * Reusable Textarea Component
 * @function Textarea
 * @param {Object} props
 * @return {ReactElement}
 * @example ./Textarea.md
 */
const Textarea = props => {
  const {
    autofocus = false,
    className,
    disabled = false,
    errorState = false,
    label,
    maxLength,
    onChange,
    onKeyPress,
    placeholder,
    resizeable = false,
    style,
    value,
    wrapperClassName,
  } = props;
  const styleObj = { ...style, resize: !resizeable ? 'none' : null };
  const maxLen = maxLength || null;

  return (
    <div className={classNames(styles.textareaWrapper, wrapperClassName)}>
      {label && <p className={styles.textareaLabel}>{label}</p>}
      <textarea
        className={classNames(
          styles.textarea,
          className,
          { [styles.textareaError]: errorState },
          { [styles.textareaDisabled]: disabled },
        )}
        placeholder={placeholder}
        autoFocus={autofocus}
        onChange={onChange}
        onKeyPress={onKeyPress}
        defaultValue={value}
        style={styleObj}
        maxLength={maxLen}
        disabled={disabled} />
    </div>
  );
};

Textarea.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  autofocus: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorState: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  resizeable: PropTypes.bool,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  wrapperClassName: PropTypes.string,
};

export default Textarea;
